module.exports = __webpack_public_path__ + "static/img/sjfx.1f00e4fd.png";